import React from 'react';
import PropTypes from 'prop-types';


const ListRight = props => {
  let ariaLabelledBy;
  let titleId;
  let descId;

  const {
    hidden, title, desc, role,
    width, height, viewBox,
    fill, className, x, y,
    handleClick
  } = props;

  if (title) {
    titleId = (Math.random() * 100000).toFixed(0);
    ariaLabelledBy = `${titleId}`;
  }

  if (desc) {
    descId = (Math.random() * 100000).toFixed(0);
    ariaLabelledBy += ` ${descId}`;
  }

  return (
    <svg id="list-right"
      className={ className } onClick={ handleClick }
      width={ width } height={ height }
      viewBox={ viewBox } x={ x } y={ y }
      fill={ fill }
      role={ role }
      aria-labelledby={ ariaLabelledBy }
      aria-hidden={ hidden }>

      {title
        ? <title id={ titleId }>{ title }</title>
        : null
      }

      {desc
        ? <desc id={ descId }>{ desc }</desc>
        : null
      }

      <g>
        <rect x="3" y="3" width="13" height="3" />
        <rect x="18" y="3" width="3" height="3" />
        <rect x="18" y="10" width="3" height="3" />
        <rect x="18" y="17" width="3" height="3" />
        <rect x="3" y="10" width="13" height="3" />
        <rect x="3" y="17" width="13" height="3" />
      </g>
    </svg>
  );
};

ListRight.defaultProps = {
  className: '',
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  x: '',
  y: '',
  fill: '#000000',
  role: 'img',
  title: '',
  desc: '',
  hidden: true
};

ListRight.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  viewBox: PropTypes.string,
  x: PropTypes.string,
  y: PropTypes.string,
  fill: PropTypes.string,
  role: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string,
  hidden: PropTypes.bool
};


export default ListRight;
